import { Component, OnInit } from '@angular/core';
import { faBell } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'porcupine-notify-popup',
  templateUrl: './notify-popup.component.html',
  styleUrls: ['./notify-popup.component.scss']
})
export class NotifyPopupComponent implements OnInit {

  faBell = faBell;

  constructor() { }

  ngOnInit(): void {
  }

}
